export const FEATURE_REQUESTS_QUERY_KEY = ["feature-requests"] as const;
